(function () {
  const root = document.querySelector('.zkpp[data-section-id]');
  if (!root) return;

  const enabled = root.dataset.enabled === 'true';
  if (!enabled) return;
  if (location.pathname.includes('/checkout')) return;

  const sid = root.dataset.sectionId;
  const KEY = `zkpp_seen_${sid}`; // session-only

  function seen() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (_) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(KEY, '1'); } catch (_) {}
  }

  function openPopup() {
    if (seen()) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
  }

  function closePopup() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    markSeen(); // ✅ لو قفلها خلاص مش هتظهر تاني في نفس الجلسة
  }

  root.querySelectorAll('[data-zkpp-close]').forEach((el) => el.addEventListener('click', closePopup));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closePopup();
  });

  // Show once on site open
  window.addEventListener('load', () => {
    setTimeout(openPopup, 600); // تأخير صغير جدًا عشان الصفحة تلحق
  });

  // (اختياري) Copy code
  const copyBtn = root.querySelector('[data-zkpp-copy]');
  const copiedEl = root.querySelector('[data-zkpp-copied]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      const code = copyBtn.dataset.code || '';
      try { await navigator.clipboard.writeText(code); } catch (_) {}
      if (copiedEl) {
        copiedEl.style.display = 'inline';
        setTimeout(() => (copiedEl.style.display = 'none'), 1200);
      }
    });
  }
})();
